module.exports = __webpack_public_path__ + "static/media/handbike1.295b721b.jpg";